
<mat-card>
  <mat-dialog-content>   
    <div class="symbolText">
        Provide symbols or CUSIPs here. iRebal will gather additional information about them, such as mutual fund<br/>
        minimums, from Charles Schwab & Company, Inc. security database before adding them to the iRebal security database.<br/>
        You can also view and select options from the option chains tab.
    </div>
    <table width="100%">
      <tr>
        <td align="left" style="vertical-align: top; width:20%;"><label class="symbolText">Enter symbols/CUSIPs or select from option chains</label></td >
        <td style="width: 60%;">
          <div class="multilineText left">
            <div class="hblock"><textarea #multilineTextInput (blur)="sendMultiLineData()" (change)="onKeyUpChange()"
                      (keyup)="onKeyUpChange()"
                      [(ngModel)]="multiLineComment"
                      [ngStyle]="{'border-color': isTextValid ? '#EAEAEA' : '#C11312'}"
                      class="multiLineComment"
                      cols="50"
                      id="w3review"
                      maxlength="1000"
                      name="w3review"
                      placeholder="" rows="4">
            </textarea></div>
            <div style="font-style: italic">Separate multiple symbols/CUSIPs with spaces</div>
          </div>       
        </td>
        <td style="width:20%;"></td>          
      </tr>
    </table>     
    </mat-dialog-content>
  </mat-card>    
 

  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="checkSecurities()" class="btn-medium-primary" [disabled]="canNotContinueD">Continue</button>
  </mat-dialog-actions>
